/**
 * @module login 
 *  Apis must need auth details to trigger url - AuthApi
 */
 import Env from '@/env';
 import NormalApis from '@/Components/Controllers/NormalApis';
 import store from '@/store/store';
 import moment from 'moment';
import Helpers from '@/Components/Helpers/Helpers';

 export default {

  /**
  * Upsert User
  */
  upsertUser(data, locationId) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId)
    return;
    // For upsert prevent all email with anonymous
    if(!data.email || data.email.indexOf('anonymous') > -1) {
      return;
    }

    const url = `${Env.vbout.url}/vbout/upsertcustomer`;
    let records = {
      email: data.email,
      uniqueid: data.id,
      firstname: data.first_name,
      lastname: data.last_name,
      phone: data.phone,
      company: "unoapp", // province not on api
      country: "CA",
      //ipaddress: '110.44.125.18',
    };
    return NormalApis.postApi(url, '', {
      vboutBody: records,
      location_id: locationId,
    })
    .then(res => res)
    .catch(err => err);
  },

  /**
  * Add user Tag
  */
   addUserTag(data, locationId) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId)
    return;
    // For upsert prevent all email with anonymous
    if(!data.email || data.email.indexOf('anonymous') > -1) {
      return;
    }

    const url = `${Env.vbout.url}/vbout/contact/addtag`;
    return NormalApis.postApi(url, '', {
      vboutBody: {
        email: data.email,
        tagname: data.tagname,
      },
      location_id: locationId,
    })
    .then(res => res)
    .catch(err => err);
  },

  /**
  * Remove user Tag
  */
   removeUserTag(data, locationId) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId)
    return;
    // For upsert prevent all email with anonymous
    if(!data.email || data.email.indexOf('anonymous') > -1) {
      return;
    }

    const url = `${Env.vbout.url}/vbout/contact/removetag`; 
    return NormalApis.postApi(url, '', {
      vboutBody: {
        email: data.email,
        tagname: data.tagname,
      },
      location_id: locationId,
    })
    .then(res => res)
    .catch(err => err);
  },

  /**
  * Product view
  */
  productView(data, productUrl, locationId) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId)
    return;
    // Now if anonymous user then do not 
    if(!store.getters.getLoggedInUser.email || (store.getters.getLoggedInUser.email == '') || (store.getters.getLoggedInUser.email.indexOf('anonymous') > -1)  ) {
      return;
    }
    let productFullName = data.name;
    if(data.brand && data.brand.name) {
      productFullName += ' '+data.brand.name.toString();
    }
    const url = `${Env.vbout.url}/vbout/addproductview`;
    let records = {
      uniqueid: store.getters.getLoggedInUser.id,
      customer: store.getters.getLoggedInUser.email,
      productid: data.id,
      name: productFullName,
     // description: data.description,
      price: data.variants[0].price,
      currency: 'CAD',
      sku: data.sku,
      image: data.image ? data.image : '',
      link: productUrl,
      categoryid: data.category ? data.category.id : '',
      category: data.category ? data.category.name : '',
      //ipaddress: '110.44.125.18',
    };
    let discountprice = (data.variants[0].sale_price < data.variants[0].price) ? data.variants[0].sale_price :  null;
    if(discountprice !== null){
      records.discountprice = discountprice;
    }
    return NormalApis.postApi(url, '', {
      vboutBody: records,
      location_id: locationId,
    })
    .then(res => res)
    .catch(err =>err);
  },


  /**
  * Create cart
  */
  createCart(cart_id, locationId, cartUrl) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId)
    return;
    // Now if anonymous user then do not 
    if(!store.getters.getLoggedInUser.email || (store.getters.getLoggedInUser.email == '') || (store.getters.getLoggedInUser.email.indexOf('anonymous') > -1)  ) {
      return;
    }

    const url = `${Env.vbout.url}/vbout/createcart`;
    let records = {
      customer: store.getters.getLoggedInUser.email,
      uniqueid: store.getters.getLoggedInUser.id,
      cartid: cart_id,
      cartcurrency: 'CAD',
      storename: store.getters['location/selected'].name ? store.getters['location/selected'].name : '',
      //ipaddress: '110.44.125.18',
      abandonurl: cartUrl,
      customerinfo: {
        firstname: store.getters.getLoggedInUser.first_name,
        lastname: store.getters.getLoggedInUser.last_name,
        phone: store.getters.getLoggedInUser.phone,
        company: "",
        country: "Canada"
      }
    };

    return NormalApis.postApi(url, '', {
      vboutBody: records,
      location_id: locationId,
    })
    .then(res => res)
    .catch(err => err);
  },


  /**
  * Empty cart
  */
  emptyCart(cartid, locationId) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId)
    return;
    // Now if anonymous user then do not 
    if(!store.getters.getLoggedInUser.email || (store.getters.getLoggedInUser.email == '') || (store.getters.getLoggedInUser.email.indexOf('anonymous') > -1)  ) {
      return;
    }

    const url = `${Env.vbout.url}/vbout/emptycart`;
    return NormalApis.postApi(url, '', {
      vboutBody:  {
        cartid: cartid,
      },
      location_id: locationId,
    })
    .then(res => res)
    .catch(err => err);
  },


  /**
  * Remove cart
  */
  removeCart(data) {
   // No where used
    return false;
    const url = `${Env.vbout.url}/vbout/removecart`;
    return NormalApis.postApi(url, '', {
      cartid: '1',
    })
    .then(res => res)
    .catch(err =>err);
  },

  /**
  * Add cart item
  */
  addCartItem(data, productUrl, locationId) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId )
    return;
    // Now if anonymous user then do not 
    if(!store.getters.getLoggedInUser.email || (store.getters.getLoggedInUser.email == '') || (store.getters.getLoggedInUser.email.indexOf('anonymous') > -1)  ) {
      return;
    }

    const url = `${Env.vbout.url}/vbout/addcartitem`;
    let productFullName = data.product_name;
    if(data.brand_name ) {
      productFullName += ' '+data.brand_name.toString();
    }
    let records = {
      customer: store.getters.getLoggedInUser.email,
      uniqueid: store.getters.getLoggedInUser.id,
      cartid: store.getters['cart/id'],
      productid: data.product_id + '-' + data.selected_variant.id, // product id = location_product_id - variant_id
      name: productFullName,
     // description: data.description,
      variation: 
      { 
        variation_id: data.selected_variant.id, 
      },
      price: data.selected_variant.price,
      discountprice: data.selected_variant.sale_price,
      currency:"CAD",
      quantity: data.unit,
      sku: data.location_variant_sku,
      image: data.product_image ? data.product_image : '',
      link: productUrl,
      categoryid: data.category_id ? data.category_id : '',
      category: data.category_name ? data.category_name : '',
    };

    return NormalApis.postApi(url, '', {
      vboutBody: records,
      location_id: locationId,
    })
    .then(res => res)
    .catch(err => err);
  },


  /**
  * Add cart item
  */
  removeCartItem(data, locationId) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId)
    return;
    // Now if anonymous user then do not 
    if(!store.getters.getLoggedInUser.email || (store.getters.getLoggedInUser.email == '') || (store.getters.getLoggedInUser.email.indexOf('anonymous') > -1)  ) {
      return;
    }

    const url = `${Env.vbout.url}/vbout/removecartitem`;
    return NormalApis.postApi(url, '', {
      vboutBody: {
        cartid : data.cartid,
        productid: data.productid + '-' + data.variation.variation_id,
        variation: data.variation,
      },
      location_id: locationId,
    })
    .then(res => res)
    .catch(err =>err);
  },



  /**
  * Create order
  */
  createOrder(data, locationId) {
    // if locaiton crm setting is not available then lets hit vbout api
    if(!store.getters['location/selectedLocationVboutStatus'] || !locationId)
    return;
    // Now if anonymous user then do not 
    if(!store.getters.getLoggedInUser.email || (store.getters.getLoggedInUser.email == '') || (store.getters.getLoggedInUser.email.indexOf('anonymous') > -1)  ) {
      return;
    }

    const url = `${Env.vbout.url}/vbout/createorder`;
    let requestData = {
      uniqueid: data.id,
      cartid: data.cart_id,
      orderid: data.id,
      ordernumber: data.id,
      paymentmethod: data.pay_later ? 'pay later' : 'pay now',
      grandtotal: data.total,
      orderdate: moment(data.receive_time).unix(),
    //  shippingmethod: 'Fedex',
      shippingcost: data.delivery_fee,
      subtotal: data.sub_total,
    //  discountcode: '10off',
    //  discountvalue: '10.00',
    //  promocode: '5off',
    //  promovalue: '5.00',
    //  taxname: '',
      taxcost: data.tax,
    //  otherfeename: 'handling fee',
    //  otherfeecost: '3.00,',
      currency: 'CAD',
      status: data.status,
      notes: data.note,
      storename: data.location.name,
      customerinfo: {
        firstname: data.user.first_name,
        lastname: data.user.last_name,
        email: data.user.email,
        phone: data.user.phone,
        company: '',
        country: "Canada",
      },
      billinginfo: {
        firstname: data.user.first_name,
        lastname: data.user.last_name,
        email: data.user.email,
        phone: data.user.phone,
        company: "",
        address: "",
        address2: "",
        city: "",
        statename: "",
        statecode: data.user.province,
        countryname: "Canada",
        countrycode: "CA",
        zipcode: "",
      },
    };

    // If delivery present then push it
    if(data.order_delivery){
      requestData.shippinginfo = {
        firstname: data.user.first_name,
        lastname: data.user.last_name,
        email: data.user.email,
        phone: data.user.phone,
        company: '',
        address: data.order_delivery.address1,
        address2: data.order_delivery.address2,
        city: data.order_delivery.city,
        statename: data.order_delivery.province,
        statecode: '',
        countryname: '',
        countrycode: '',
        zipcode: data.order_delivery.postal_code,
      };
    }
    
    return NormalApis.postApi(url, '', {
      vboutBody: requestData,
      location_id: locationId,
    })
    .then(res => res)
    .catch(err => err);
  },

 }